/*
 * jQuery Plugin: jQuery Facebook Album Browser
 * Version 1.9.8
 * Rebuild to suit our needs, so it's like 11 not 44KB. DON'T UPDATE!
 */

(function ($) {
    $.fn.FacebookAlbumBrowser = function (options) {
        var defaults = {
            account: "",
            accessToken: "",
            showAccountInfo: true,
            showImageCount: true,
            skipEmptyAlbums: true,
            showComments: true,
            commentsLimit: 5,
            skipAlbums: [],
            includeAlbums: [],
            onlyAlbum: null,
            thumbnailSize: 130,
            showAlbumNameInPreview: true,
            lightbox: true,
            photosCheckbox: true,
            albumSelected: null,
            photoSelected: null,
            photoChecked: null,
            photoUnchecked: null,
            showImageText: false,
            likeButton: true,
            shareButton: true,
            addThis: null,
            pluginImagesPath: "src/",
            albumsPageSize: 0,
            albumsMoreButtonText: "more albums...",
            photosPageSize: 0,
            photosMoreButtonText: "more photos...",
            checkedPhotos: []
        }

        var settings = $.extend({}, defaults, options);
        var selector = $(this);
        var openGraphApiUrl = "https://graph.facebook.com/";
        var albumFields = "&fields=id,count,cover_photo,created_time,from,link,name,type,updated_time";
        var photoFields = "&fields=id,created_time,from,height,icon,images,link,name,picture,updated_time,width,source";

        selector.each(function (index) {
            var container = selector.get(index);
            var invokeUrl = "";
            if (settings.showAccountInfo) {
                addAccountInfo(container);
            }

            if (settings.onlyAlbum == null) {
                $(container).append($('<ul>', {
                    class: "fb-albums",

                }));
                invokeUrl = openGraphApiUrl + settings.account + "/albums";
                if (settings.accessToken != "") {
                    invokeUrl += "?access_token=" + settings.accessToken + albumFields;
                }
            }
            else {
                invokeUrl = openGraphApiUrl + settings.onlyAlbum + "/photos";
                if (settings.accessToken != "") {
                    invokeUrl += "?access_token=" + settings.accessToken + photoFields;
                }
            }
            var albumList = $(container).find(".fb-albums");


            if (settings.onlyAlbum != null) {
                loadPhotos(invokeUrl, $(container));
            }
            else {
                loadAlbums(invokeUrl);
            }

            function loadAlbums(url) {

                $(albumList).addClass("fb-loading-image");

                $.ajax({
                    type: 'GET',
                    url: url,
                    cache: false,
                    dataType: 'jsonp',
                    success: function (result) {
                        if ($(result.data).length > 0) {

                            if (settings.albumsPageSize != null && settings.albumsPageSize > 0) {
                                var moreButton = $(container).find(".fb-btn-more");
                                if (moreButton.length == 0) {
                                    moreButton = $("<div>", { class: "fb-btn-more fb-albums-more", text: settings.albumsMoreButtonText });
                                    //$(container).append(moreButton);
                                    $(moreButton).click(function () {
                                        var _this = $(this);
                                        $(container).find("li.fb-album:hidden").slice(0, settings.albumsPageSize).fadeIn(function () {
                                            if ($(container).find("li.fb-album:hidden").length == 0) {
                                                _this.fadeOut(function () {
                                                    _this.remove();
                                                });
                                            }
                                        });


                                    });
                                }
                            }

                            for (var a = 0; a < $(result.data).length; a++) {

                                if (settings.skipAlbums.length > 0 && (settings.skipAlbums.indexOf($(result.data).get(a).name) > -1 || settings.skipAlbums.indexOf($(result.data).get(a).id.toString()) > -1)) {
                                    continue;
                                }
                                if (settings.includeAlbums.length > 0 && (settings.includeAlbums.indexOf($(result.data).get(a).name) < 0 && settings.includeAlbums.indexOf($(result.data).get(a).id.toString()) < 0)) {
                                    continue;
                                }

                                var albumListItem = $("<li>", {
                                    class: "fb-album",
                                    "data-id": $(result.data).get(a).id,
                                });
                                if ($(result.data).get(a).count == null && settings.skipEmptyAlbums) {
                                    continue;
                                }
                                else {
                                    var coverPhoto = $(result.data).get(a).cover_photo;
                                    var invokeUrl = openGraphApiUrl
                                    if (typeof coverPhoto != "undefined") {
                                        if(!isNaN(coverPhoto)){
                                            invokeUrl += coverPhoto;
                                        }
                                        else {
                                            invokeUrl += coverPhoto.id;
                                        }
                                    }
                                    //var invokeUrl = openGraphApiUrl + $(result.data).get(a).cover_photo;
                                    if (settings.accessToken != "") {
                                        invokeUrl += "?access_token=" + settings.accessToken + photoFields;
                                    }
                                    $.ajax({
                                        type: 'GET',
                                        url: invokeUrl,
                                        cache: false,
                                        data: { album: $(result.data).get(a).id },
                                        dataType: 'jsonp',
                                        success: function (cover) {
                                            var listItem = $("li.fb-album[data-id='" + getParameterByName("album", $(this).get(0).url) + "'] ");
                                            if (!$(cover).get(0).error && $(cover).get(0).images) {
                                                var prefWidth = listItem.width();
                                                var prefHeight = listItem.height();
                                                var albumImg = $(cover.images)[0];
                                                var albumUrl;

                                                var str = JSON.stringify(cover, null, 4); // (Optional) beautiful indented output.
                                                //alert(str); // Displays output using window.alert()

                                                for (var i = 0; i < $(cover.images).length; i++) {
                                                    if (
                                                            ($(cover.images)[i].height >= prefHeight && $(cover.images)[i].width >= prefWidth) &&
                                                            ($(cover.images)[i].height <= albumImg.height && $(cover.images)[i].width <= albumImg.width)
                                                        ) {
                                                        albumImg = $(cover.images)[i];
                                                    }

                                                    albumUrl = $(result.data)[i].link;
                                                }
                                                var albLnk = "//www.facebook.com/pg/huishurenibiza.nl/photos/?tab=album&album_id=" + getParameterByName('album', $(this).get(0).url) + "";
                                                var albumThumb = $("<img>", { "data-albumlink": albumUrl, "data-id": $(cover).get(0).id, class: "fb-album-thumb", "data-src": albumImg.source, src: albumImg.source })
                                                var link = $("<a>", { "href": albLnk, "class": "Link Link--absolute", rel: "nofollow", target: "_blank"  })
                                                listItem.append(albumThumb);
                                                listItem.append(link);
                                            }
                                            else {
                                                listItem.remove();
                                            }
                                        }
                                    });
                                    $(albumList).append(albumListItem);
                                    $(albumList).removeClass("fb-loading-image");
                                    if (settings.albumsPageSize > 0 && $(albumList).find("li").index(albumListItem) >= settings.albumsPageSize) {
                                        albumListItem.remove();

                                    }
                                }
                            }

                            if (result.paging && result.paging.next && result.paging.next != "") {
                                loadAlbums(result.paging.next);
                            }
                            //cond end
                        }
                    }
                });
            }



            function getParameterByName(name, url) {
                name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
                var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                    results = regex.exec(url);
                return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
            }


        });

        return this;
    }
})(jQuery);
